var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecyclingCoral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.559 131.559",
    style: {
      enableBackground: "new 0 0 131.559 131.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Recycling_-_Coral"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M93.333,65.779 l13.294,22.395c3.849,6.485-0.824,14.693-8.365,14.693l-21.942,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F18C7E"
    },
    points: "84.287,96.087 77.502,102.868 84.287,109.649 78.529,109.649 71.748,102.868  78.529,96.087  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M38.225,65.78 l19.189-32.326c3.769-6.35,12.961-6.35,16.73,0l13.988,23.24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F18C7E"
    },
    points: "78.214,53.364 87.523,55.681 89.834,46.37 92.803,51.303 90.49,60.61 81.183,58.297  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M65.78,102.868H33.297 c-7.541,0-12.214-8.209-8.365-14.693l8.026-13.311"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F18C7E"
    },
    points: "34.651,85.188 32.347,75.876 23.037,78.185 26.01,73.254 35.319,70.949 37.624,80.257  "
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M113.11,129.559H18.449 C9.364,129.559,2,122.195,2,113.11V18.449C2,9.364,9.364,2,18.449,2h94.662c9.084,0,16.449,7.364,16.449,16.449v94.662 C129.559,122.195,122.195,129.559,113.11,129.559z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecyclingCoral);
export default __webpack_public_path__ + "static/media/Recycling - Coral.8c84df70c2f989e40007a657178a797c.svg";
export { ForwardRef as ReactComponent };